'use client'

import dynamic from 'next/dynamic'

const NotFoundLocaleEnabler = dynamic(
	() => import('./NotFoundLocaleEnabler').then((mod) => mod.default),
	{
		ssr: false,
	},
)

const Index = () => {
	return <NotFoundLocaleEnabler />
}

export default Index
